import LanguageDropdown from "components/Language/LanguageDropdown"
import React, { Component } from "react"
import { Link, withRouter } from "react-router-dom"
import { Button, Icon, Modal } from "semantic-ui-react"
import queryString from "qs"
import shop from "shop/shop"
import FormCMS from "components/Form/FormCMS"
import WordPressContainer from "WordPressContainer"
import historyStore from "stores/historyStore"

@withRouter
export default class NewCustomerPage extends Component {
  
  render() {
    
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    const { overlay } = query
    const { history } = this.props
    
    return (
      <div>
        {overlay && <Modal open={true}>
          <Button
            className="absolute right-1 top-1"
            as={Link}
            to={this.props.location.pathname}
            circular
            basic
            icon={"close"}
          />
          
          <Modal.Content>
            <WordPressContainer slug={overlay}/>
          </Modal.Content>
          
          <Modal.Actions>
            <Button
              as={Link}
              to={this.props.location.pathname}
              labelPosition="right"
              content={translate("Zurück")}
            />
          </Modal.Actions>
        
        </Modal>}
        <div className="pa3">
          <div className="fr"><LanguageDropdown/></div>
          <Button as={Link} to="/login"><Icon name="chevron left"/>{translate( "back to login" )}</Button>
        
        </div>
        <div className="mw7 center pt2 pb6">
          
          <div className="tc pb4">
            <Link to="/login">
              <img src={shop.config.logo} title="Zur Startseite"/>
            </Link>
          </div>
          
          <FormCMS slug={"customer_registration"} onSuccess={() => {
            const previousLocation = historyStore.getPreviousLocation()
            if ( previousLocation ) {
              history.push( previousLocation.pathname + previousLocation.search )
            }
            window.swal( translate( "Neukundenanmeldung erhalten" ), translate( "Vielen Dank für Ihre Anmeldung. Sie erhalten Ihre Anmeldedaten per E-Mail" ),
              "success" )
          }}/>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/NewCustomerPage.js